import { __ } from '@wordpress/i18n'

import type { Address } from '../libs/type'

export type OrderAddressProps = {
  address: Address
  type: 'billing' | 'shipping'
}

export function OrderAddress({ address, type }: Readonly<OrderAddressProps>) {
  return (
    <div>
      <h2 className="mb-2 font-medium uppercase">
        {type === 'billing'
          ? __('Billing address', 'asavagroup')
          : __('Shipping address', 'asavagroup')}
      </h2>
      <address className="text-sm not-italic">
        <p>
          {address.firstName} {address.lastName}
        </p>
        {address.company && <p>{address.company}</p>}
        {address.address1 && <p>{address.address1}</p>}
        {address.address2 && <p>{address.address2}</p>}
        {address.city && <p>{address.city}</p>}
        {address.state && <p>{address.state}</p>}
        {address.postcode && <p>{address.postcode}</p>}
        {address.country && <p>{address.country}</p>}
        {address.phone && <p>{address.phone}</p>}
        {address.email && <p>{address.email}</p>}
      </address>
    </div>
  )
}

export default OrderAddress
